// This JavaScript file is created by Cision for our ticker trades module.
// This is the first version of this file so far.
// This should be combined with trades.html

var cision = cision || {};
cision.websolution = cision.websolution || {};
cision.websolution.texts = cision.websolution.texts || {};
cision.websolution.settings = cision.websolution.settings || {};
cision.websolution.formatHelpers = cision.websolution.formatHelpers || {};

cision.websolution.trades = !cision.websolution.settings.ticker ? {}: function ($) {
    var settings = $.extend({}, cision.websolution.settings.general),
        accessKey = cision.websolution.settings.ticker.accessKey,
        texts = cision.websolution.texts[settings.uiLanguage];

    function generateUrl(path) {
        var url = settings.useProxyHandler
            ? settings.proxyHandler + '?url=' + settings.serviceEndpoint + path
            : settings.serviceEndpoint + path;

        return url;
    }
    var renderTrades = function (options) {

        if (options) {
            $.extend(settings, options);
        }
        if (!accessKey) {
            console.log("You must provide your ticker access key.");
            return;
        }
        var url = generateUrl('Ticker/' + accessKey + '/Trades');

        $.ajax({
            url: url,
            type: 'GET',
            dataType: 'json'
        })
            .done(function (rawData) {
                // Retrieve the Instrument
                var objInstrument = rawData.Instruments[0]; // TODO: find the correct instrument, in case we have many in the Module
                $.each(objInstrument.Trades, function (idx, objTrade) {
                    objTrade.TradeTimeFormatted = moment(objTrade.TradeTime).locale(settings.uiLanguage).format(settings.dateFormatTrades);
                });

                var compositeModel = $.extend(objInstrument, texts, settings);

                var renderedHtml = $("#tplTickerTrades").render(compositeModel, cision.websolution.formatHelpers);
                $("#target-trades").html(renderedHtml);
            })
            .fail(function() {
                console.log('Could not retrieve trades data');
            })
            .always(function() {

            });
    };

    return {
        render: renderTrades,
        renderTrades: renderTrades
    };
}(jQuery);